"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveProductButton = void 0;
const React = require("react");
const colors_1 = require("../../../../../../types/colors");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "RemoveProductButton");
/**
 * Icon to completely remove a product from the cart
 */
const RemoveProductButton = ({ salesOrderItem, removeSalesOrderItemFromSalesOrder, isUpdatingCart }) => (React.createElement(Button_1.Button, { className: css(""), variant: "secondary", size: standardSizes_1.TStandardSizes.Small, status: colors_1.TColorVariants.Danger, icon: "cancel", onClick: async () => !isUpdatingCart && removeSalesOrderItemFromSalesOrder(salesOrderItem) }, "remove"));
exports.RemoveProductButton = RemoveProductButton;
//# sourceMappingURL=index.js.map